/** Google Play trailer capture (landscape). */
export const RECORDING_FRAME_GOOGLE_1080P = {
    width: 1920,
    height: 1080,
    kind: "google-1080p",
};

/** App Store preview / Apple trailer capture (portrait iPhone). */
export const RECORDING_FRAME_APPLE = {
    width: 1290,
    height: 2796,
    kind: "apple",
};

/**
 * Resolve fixed capture frame from a jigsaw recording pathname.
 * @param {string} [pathname]
 * @returns {{ width: number, height: number, kind: string } | null}
 */
export function getJigsawRecordingCaptureFrame(pathname) {
    if (typeof pathname !== "string") return null;
    if (pathname.includes("/recording/apple")) {
        return RECORDING_FRAME_APPLE;
    }
    if (pathname.includes("/recording/1080p")) {
        return RECORDING_FRAME_GOOGLE_1080P;
    }
    return null;
}
